export default __webpack_public_path__ + "static/media/Q-1U-HYBRID-FRONT.9010fdeb.png";